<template>
    <div class="panel-container" :style="{'height': (documentClientHeight) + 'px'}">
        <el-row class="panel-group" style="margin-bottom: 10px">
            <div style="height: 50px; background: #fff;font-weight: bold">
                <div style="display: inline-block;line-height: 50px;float:left;">
                    <span style="border-left: 5px solid red;margin: 0 10px 0 20px;"></span>
                    <span>采购策略</span>
                </div>
                <el-menu default-active="1" class="el-menu-demo" mode="horizontal" style="float: left;margin-left: 50px;">
                    <el-badge :value="12" class="item">
                        <el-menu-item index="1">处理中</el-menu-item>
                    </el-badge>
                    <el-badge :value="2" class="item">
                        <el-menu-item index="2">已完成</el-menu-item>
                    </el-badge>
                </el-menu>
            </div>
        </el-row>
        <el-row class="panel-group">
            <div class="content-body tenant-settings" style="background: #fff;padding: 20px;">
                <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="listTenants()" style="background: #f9f9f9;padding: 10px 10px 0 10px">
                    <el-form-item label="编码:">
                        <el-input size="small" v-model="dataForm.code" placeholder="编码" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="名称:">
                        <el-input size="small" v-model="dataForm.name" placeholder="名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" @click="listTenants()" icon="el-icon-search">查询
                        </el-button>
                        <el-button size="small" type="primary" @click="addOrUpdateHandle()"
                                   icon="el-icon-plus">新增
                        </el-button>
                        <el-button size="small" type="danger" @click="deleteHandle()"
                                   :disabled="dataListSelections.length <= 0" icon="el-icon-delete">批量删除
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="dataList"
                        v-loading="dataListLoading"
                        size="small"
                        border
                        stripe
                        @selection-change="selectionChangeHandle"

                        style="width: 100%;margin-top: 20px;min-height: 800px;">
                    <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            width="50"
                            label="序号">
                    </el-table-column>
                    <el-table-column
                            prop="tenantCode"
                            header-align="left"
                            align="left"
                            label="物料信息">
                        <template>
                            <p>物料编码：xxxxxx</p>
                            <p>物料名称：零件CCCCCCC</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="tenantName"
                            header-align="left"
                            align="left"
                            label="规格">
                    </el-table-column>
                    <el-table-column
                            header-align="left"
                            align="left"
                            width="300"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)" icon="el-icon-edit">修改
                            </el-button>
                            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageIndex"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        :total="totalPage"
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'Panel',
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] + 300,
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [1,1],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                menuUpdateVisible: false
            }
        },
        mounted() {
            let myChart = this.$echarts.init(document.getElementById('main1'));
            myChart.setOption({
                title: {
                    text: '近期审批'
                },
                tooltip: {},
                xAxis: {
                    data: ['1月', '2月', '3月', '4月', '5月', '六月']
                },
                yAxis: {},
                series: [{
                    name: '数量',
                    type: 'bar',
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#83bff6'},
                                {offset: 0.5, color: '#188df0'},
                                {offset: 1, color: '#188df0'}
                            ]
                        )
                    },
                    emphasis: {
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: '#2378f7'},
                                    {offset: 0.7, color: '#2378f7'},
                                    {offset: 1, color: '#83bff6'}
                                ]
                            )
                        }
                    },
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
            let myChart2 = this.$echarts.init(document.getElementById('main2'));
            myChart2.setOption({
                title: {
                    text: '处理任务'
                },
                xAxis: {
                    type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月', '6月']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [150, 230, 224, 218, 135, 147, 260],
                    type: 'line'
                }]
            })
            let myChart3 = this.$echarts.init(document.getElementById('main3'));
            myChart3.setOption({
                title: {
                    text: '预算 vs 开销'
                },
                legend: {
                    data: ['预算分配', '实际开销'],
                    right: '0'
                },
                radar: {
                    // shape: 'circle',
                    indicator: [
                        { name: '需求申请', max: 6500},
                        { name: '需求分配', max: 16000},
                        { name: '方案制定', max: 30000},
                        { name: '方案审核', max: 38000},
                        { name: '方案审批', max: 25000},
                        { name: '采购寻源', max: 52000},
                        { name: '结果审批', max: 25000}
                    ]
                },
                series: [{
                    name: '预算 vs 开销',
                    type: 'radar',
                    data: [
                        {
                            value: [4200, 3000, 20000, 35000, 20000, 50000, 18000],
                            name: '预算分配'
                        },
                        {
                            value: [5000, 14000, 28000, 26000, 22000, 42000, 21000],
                            name: '实际开销'
                        }
                    ]
                }]
            })
        },
    }
</script>

<style lang="scss">
    .el-menu-demo{
        .el-badge{
            height: 40px;
            .el-badge__content{
                margin-top: 10px;
                right: 15px;
            }
        }
    }
    .box-card{
        .el-card__header{
            span{
                i{
                    margin-right: 5px;
                }
            }
            .icon-1 {
                color: #40c9c6;
            }

            .icon-2 {
                color: #36a3f7;
            }

            .icon-3 {
                color: #f4516c;
            }

            .icon-4 {
                color: #34bfa3
            }
        }
    }
    .panel-item{
        font-size: 14px;
        padding: 5px 0;
    }
    .icon-tip-num {
        text-align: right;
        margin: 10px 20px 0 0;
        color: #36a3f7;
        font-size: 60px;
    }
    .panel-container {
        /*padding: 32px;*/
        /*background-color: rgb(240, 242, 245);*/
        position: relative;
        height: 100%;
    }

    .card-block{
        .card-panel-col {
            padding-right: 0px !important;
            padding-left: 10px !important;
        }
        .card-panel-col:last-child{
            padding-right: 20px !important;
        }
        .card-panel-col:first-child{
            padding-left: 20px !important;
        }
    }

    .panel-group {
        /*margin-top: 18px;*/

        .card-panel-col {
            margin: 0 0 10px 0;
        }

        .card-panel {
            height: 108px;
            cursor: pointer;
            font-size: 12px;
            position: relative;
            overflow: hidden;
            color: #666;
            background: #fff;
            box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
            border-color: rgba(0, 0, 0, .05);
            border-radius: 3px;

            i {
                font-size: 40px;
            }

            &:hover {
                .card-panel-icon-wrapper {
                    color: #fff;
                }

                .icon-1 {
                    background: #40c9c6;
                }


                .icon-3 {
                    background: #f4516c;
                }

                .icon-4 {
                    background: #34bfa3
                }
            }

            .card-panel-icon-wrapper {
                float: left;
                margin: 14px 0 0 14px;
                padding: 16px;
                transition: all 0.38s ease-out;
                border-radius: 6px;
            }

            .card-panel-icon {
                float: left;
                font-size: 48px;
            }

            .card-panel-description {
                float: right;
                font-weight: bold;
                margin: 26px;
                margin-left: 0px;

                .card-panel-text {
                    line-height: 18px;
                    color: rgba(0, 0, 0, 0.45);
                    font-size: 16px;
                    margin-bottom: 12px;
                }

                .card-panel-num {
                    font-size: 20px;
                }
            }
        }
    }
</style>
